import React from "react";
import { Header } from "semantic-ui-react";

import "./style.css";

const Portfolio = () => {
    return (
        <>
            <Header as="h1" id="portfolio-header">Portfolio</Header>
        </>
    );
};

export default Portfolio;